import { render, staticRenderFns } from "./CardPaket.vue?vue&type=template&id=e5f499c4&"
import script from "./CardPaket.vue?vue&type=script&lang=js&"
export * from "./CardPaket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports